import { Field, Form, Formik } from 'formik'
import React, { useState } from 'react'
import { Button, Col, FormControl, InputGroup, Modal, Row, Spinner, Toast, ToastContainer } from 'react-bootstrap'
import { CheckCircle, Eye, EyeSlash } from '../../../constant/icons/icons';
import { customerPasswordSchema } from '../../../schema/validationSchemas';
import { changeCutomerPassword } from '../../../store/customerSlice';
import { useDispatch } from 'react-redux';

const ChangeCustomerPassword = ({ show, changePwId, handleClose,setOpenChangePw}) => {
    const dispatch = useDispatch();
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarVariant, setSnackbarVariant] = useState("success");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

      const initialCustomerPasswordUpdate = {
        customer_id:changePwId,
        new_password: "",
        new_password_confirmation: "",
      };

    const handleSubmit = (values, { setSubmitting, setErrors }) => {
        dispatch(changeCutomerPassword(values))
        .then((action) => {
            if (action?.payload && action?.payload?.success) {  
            setSnackbarMessage("Organization password updated successfully.");
            setSnackbarVariant("success");
            setShowSnackbar(true);
            }else {
            setErrors(action.payload.message);
            setSnackbarMessage(action.payload.message || "Failed to update Organization password");
            setSnackbarVariant("danger");
            setShowSnackbar(true);
            }
            setSubmitting(false);
        })
        .catch((error) => {
            setSnackbarMessage(
            "Update failed: Network or server error" + error.message
            );
            setSnackbarVariant("danger");
            setShowSnackbar(true);
        })
        .finally(() => {
            setSubmitting(false);
            setOpenChangePw(false);
        });
    };
    

  return (
    <>
     <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1060 }}>
        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
        >
         <Toast.Body style={{ color: "white", display: 'flex', alignItems: 'center' }}>
          <CheckCircle size={20} color="white" style={{ marginRight: 8 }} />
          {snackbarMessage}
        </Toast.Body>
        </Toast>
      </ToastContainer>
       <Modal show={show} onHide={handleClose} centered>
         <Modal.Header closeButton>
           <Modal.Title>Change Organization Password</Modal.Title>
         </Modal.Header>
        <Formik   
            initialValues={initialCustomerPasswordUpdate}
            validationSchema={customerPasswordSchema}
            onSubmit={handleSubmit}>
                
          {({ values, resetForm, isSubmitting, errors, touched }) => (
            <>
            {/* {console.log("values",values)} */}
            <Form>
              <div className="d-inline-block w-100 profile-content">
                <Row className="flex-column">
                  <Col className="p-6">
                    <Row className="gy-3">
                      <Col xl={12} lg={12} md={12} xs={12}>
                        <label className="form-label ms-1">
                          New Password
                        </label>
                        <InputGroup>
                          <Field
                            name="new_password"
                            type={
                              showNewPassword ? "text" : "password"
                            }
                            as={FormControl}
                            placeholder="Enter new password"
                            isInvalid={
                              errors?.new_password &&
                              touched?.new_password
                            }
                            className="shadow-none"
                          />
                          <InputGroup.Text
                            className="eye-spacing"
                            onClick={() =>
                              setShowNewPassword(!showNewPassword)
                            }
                          >
                            {showNewPassword ? (
                              <Eye
                                size={19}
                                color="#637381"
                                weight="duotone"
                                className="cursor-pointer"
                              />
                            ) : (
                              <EyeSlash
                                size={19}
                                color="#637381"
                                weight="duotone"
                                className="cursor-pointer"
                              />
                            )}
                          </InputGroup.Text>
                        </InputGroup>
                        {errors?.new_password &&
                          touched?.new_password && (
                            <div className="invalid-feedback ms-1 d-block">
                              {errors?.new_password}
                            </div>
                          )}
                      </Col>

                      <Col xl={12} lg={12} md={12} xs={12}>
                        <label className="form-label ms-1">
                          Confirmation Password
                        </label>
                        <InputGroup>
                          <Field
                            name="new_password_confirmation"
                            type={
                              showConfirmPassword
                                ? "text"
                                : "password"
                            }
                            as={FormControl}
                            placeholder="Enter confirmation password"
                            isInvalid={
                              errors?.new_password_confirmation &&
                              touched?.new_password_confirmation
                            }
                            className="shadow-none"
                          />
                          <InputGroup.Text
                            className="eye-spacing"
                            onClick={() =>
                              setShowConfirmPassword(
                                !showConfirmPassword
                              )
                            }
                          >
                            {showConfirmPassword ? (
                              <Eye
                                size={19}
                                color="#637381"
                                weight="duotone"
                                className="cursor-pointer"
                              />
                            ) : (
                              <EyeSlash
                                size={19}
                                color="#637381"
                                weight="duotone"
                                className="cursor-pointer"
                              />
                            )}
                          </InputGroup.Text>
                        </InputGroup>
                        {errors?.new_password_confirmation &&
                          touched?.new_password_confirmation && (
                            <div className="invalid-feedback ms-1 d-block">
                              {errors.new_password_confirmation}
                            </div>
                          )}
                      </Col>

                      <Col className="d-flex justify-content-end" xl={12} lg={12} md={12} xs={12}>
                        <div className="d-flex align-items-center gap-3 mt-2">
                          <Button variant="secondary" onClick={handleClose}>
                            Close
                          </Button>
                          <Button
                            type="button"
                            className="pr-cl-btn border-0"
                            onClick={() => resetForm()}
                            disabled={isSubmitting}
                          >
                            Clear
                          </Button>
                          <Button
                            type="submit"
                            className="pr-sv-btn border-0"
                            disabled={isSubmitting}
                          >
                            {/* Save */}
                             {isSubmitting ? (
                                <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                />
                            ) : (
                                "Save"
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Form>
            </>
          )}
        </Formik>
      </Modal>
    </>
  )
}

export default ChangeCustomerPassword